'use client';
import React from 'react';
import Base from '../../layouts/Base';
import s from './ErrorPage.module.scss';
import ErrorItem from '../../components/ErrorItem/ErrorItem';

import { t } from '../../i18n';

const ErrorPage = () => {
    const links = [
        {
            title: t('errorPage.links.startPage'),
            url: '/',
        },
    ];

    const richText = `<p>If you require further assistance, please contact our support team at <a href="mailto:tech@t-box.se">tech@t-box.se</a>.<br/> Thank you for your understanding.</p>`;
    return (
        <div className={s.Root}>
            <main className={s.Main}>
                <div className={s.Content}>
                    <ErrorItem
                        title={t('errorPage.title')}
                        label={t('errorPage.label')}
                        description={t('errorPage.description')}
                        image={{
                            src: '/img/error-image.png',
                            alt: 'Error 404',
                        }}
                        links={links}
                        richText={richText}
                    />
                </div>
            </main>
        </div>
    );
};

ErrorPage.propTypes = {};
export const RawErrorPage = ErrorPage;
export default Base(ErrorPage, { isErrorPage: true });
